module.exports = __webpack_public_path__ + "static/img/classcard-two.12e1d3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/classcard-two.png
// module id = hzUL
// module chunks = 0